import React from 'react';
import { connect } from 'react-redux';
import dialog from '../../apis/dialog';
import ChatHup from './efect10';
import ChatHup4 from './efect5';
import ChatHup2 from './efect2';
import Loading from './load';
import { Container, Row, Form, Col } from 'react-bootstrap';
import { scope, keyPrivate, iss } from '../../apis/stringConnection';
let GAPI = require('gapitoken');

class efectX extends React.Component {

    state = {
        token: null
    }

    componentDidMount() {
         this.sessionId =  Math.round(Math.random() * 15000000);
  
        let gapi = new GAPI({
            iss: iss,
            scope: scope,
            key: keyPrivate
        }, () => {
            gapi.getToken((err, token) => {
                if (err) { console.log(err); }
                console.log('genero token');
                console.log(token);
                this.setState({ token });
            });
        });

    }
    render() {

        let chat = null;
        if (this.state.token !== null) {
            switch (this.props.efect)
            //switch (this.props.efect) 
            {
                //   switch (this.state.efectos) {
                case 1:
                    chat = <ChatHup tipo={this.state.efectosAux} messageBot={'hola buenos dias'} />
                    break;
                case 2:
                    chat = <ChatHup2 token={this.state.token} sessionId = {this.sessionId} />
                    break;
                case 3:
                    chat = <ChatHup4 />
                    break;

                default:
                    chat = <Loading />
                    break;
            }
            return (
                <Container >
                    {chat}
                </Container >
            );
        }
        else {
            return <div></div>;
        }
    }
};

const mapAppStateToProps = (state) => (
    {

    });


export default connect(mapAppStateToProps, {})(efectX);